import React from "react";

// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
// @material-ui/icons
import Business from "@material-ui/icons/Business";
import People from "@material-ui/icons/People";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";

// import cardBlog3 from "assets/img/examples/card-blog3.jpg";
import CardAvatar from "../../components/Card/CardAvatar";
import Muted from "../../components/Typography/Muted";
import intl from 'react-intl-universal';
import Check from "@material-ui/core/SvgIcon/SvgIcon";



const useStyles = makeStyles(styles);

export default function WelcomePrice() {
	const [activeRotate1, setActiveRotate1] = React.useState("");
	const [activeRotate2, setActiveRotate2] = React.useState("");
	const [activeRotate3, setActiveRotate3] = React.useState("");
	const classes = useStyles();
	React.useEffect(() => {
		if (window) {
			window.addEventListener("resize", addStylesForRotatingCards);
		}
		addStylesForRotatingCards();
		return function cleanup() {
			if (window) {
				window.removeEventListener("resize", addStylesForRotatingCards);
			}
		};
	});
	const addStylesForRotatingCards = () => {
		var rotatingCards = document.getElementsByClassName(classes.cardRotate);
		for (let i = 0; i < rotatingCards.length; i++) {
			var rotatingCard = rotatingCards[i];
			var cardFront = rotatingCard.getElementsByClassName(classes.front)[0];
			var cardBack = rotatingCard.getElementsByClassName(classes.back)[0];
			cardFront.style.height = "unset";
			cardFront.style.width = "unset";
			cardBack.style.height = "unset";
			cardBack.style.width = "unset";
			var rotatingWrapper = rotatingCard.parentElement;
			var cardWidth = rotatingCard.parentElement.offsetWidth;
			var cardHeight = rotatingCard.children[0].children[0].offsetHeight;
			rotatingWrapper.style.height = cardHeight + "px";
			rotatingWrapper.style["margin-bottom"] = 30 + "px";
			cardFront.style.height = "unset";
			cardFront.style.width = "unset";
			cardBack.style.height = "unset";
			cardBack.style.width = "unset";
			cardFront.style.height = cardHeight + 35 + "px";
			cardFront.style.width = cardWidth + "px";
			cardBack.style.height = cardHeight + 35 + "px";
			cardBack.style.width = cardWidth + "px";
		}
	};
	return (
		<div className="cd-section" id="WelcomePrice">
			<div
				// className={classes.sectionGray}
			>
				<div>
					<div>
						<div className={classes.container}>
							<GridItem xs={12} sm={7} md={7}>
								<div className={classes.title}>
									<h3>{intl.get('subscription_content')}</h3>
									<h4>
										{intl.get('subscription_content_info')}
									</h4>
									<br/>
								</div>
							</GridItem>
							<GridContainer>

								<GridContainer>
									<GridItem xs={12} sm={6} md={6} lg={4} style={{marginTop: '24px'}}>
										<Card
											pricing
											// background
											// style={{backgroundImage: `url(${cardBlog3})`}}
										>

											<CardBody>

												<h3 >
													<b>普通用户</b>
												</h3>

												<h2>
													<small><small>¥</small></small>&nbsp;<b>0</b>
												</h2>

												<Button href={"/series_info/1"} style={{width: '100%', fontSize: '14pt'}}
														color={"primary"}>
													立即使用
												</Button>

												{/*<Divider/>*/}
												<GridContainer justify="flex-start"
															   style={{marginTop: '16px'}}>
													<GridItem xs={10} sm={10} md={10} lg={10}
															  style={{marginTop: '8px'}}>
														<b
															style={{
																fontSize: '12pt',
																color: '#595959',
																textAlgin: 'left'
															}}>4个完整的试看视频</b>
													</GridItem>
													<GridItem xs={1} sm={1} md={1} lg={1}
															  style={{marginTop: '8px'}}>
														<Check color={"secondary"}/>
													</GridItem>

													<GridItem xs={10} sm={10} md={10} lg={10}
															  style={{marginTop: '8px'}}>
														<b
															style={{
																fontSize: '12pt',
																color: '#595959'
															}}>完整的题目可视化动画展示</b>
													</GridItem>
													<GridItem xs={1} sm={1} md={1} lg={1}
															  style={{marginTop: '8px'}}>
														<Check color={"secondary"}/>
													</GridItem>

													<GridItem xs={10} sm={10} md={10} lg={10}
															  style={{marginTop: '8px'}}>
														<b
															style={{
																fontSize: '12pt',
																color: '#595959'
															}}>相关代码及内容的查看</b>
													</GridItem>
													<GridItem xs={1} sm={1} md={1} lg={1}
															  style={{marginTop: '8px'}}>
														<Check color={"secondary"}/>
													</GridItem>
												</GridContainer>

											</CardBody>
										</Card>
									</GridItem>

									<GridItem xs={12} sm={6} md={6} lg={4} style={{marginTop: '24px'}}>
										<Card
											pricing
											// background
											// style={{backgroundImage: `url(${cardBlog3})`}}
										>

											<CardBody>

												<h3 >
													<b>RobinAlgo会员</b>
												</h3>

												<h2>
													<small><small><small>低至</small></small></small><small><small>¥&nbsp;</small></small><b>0.49</b><small><small><small>&nbsp;/每天</small></small></small>
												</h2>

												<Button href={"/plans"} style={{width: '100%', fontSize: '14pt'}}
														color={"rose"} >
													<span>即刻升级</span>

												</Button>

												{/*<Divider/>*/}
												<GridContainer justify="flex-start"
															   style={{marginTop: '16px'}}>
													<GridItem xs={10} sm={10} md={10} lg={10}
															  style={{marginTop: '8px'}}>
														<b
															style={{
																fontSize: '12pt',
																color: '#595959',
																textAlgin: 'left'
															}}>100+完整的视频观看</b>
													</GridItem>
													<GridItem xs={1} sm={1} md={1} lg={1}
															  style={{marginTop: '8px'}}>
														<Check color={"secondary"}/>
													</GridItem>

													<GridItem xs={10} sm={10} md={10} lg={10}
															  style={{marginTop: '8px'}}>
														<b
															style={{
																fontSize: '12pt',
																color: '#595959'
															}}>完整的题目可视化动画展示</b>
													</GridItem>
													<GridItem xs={1} sm={1} md={1} lg={1}
															  style={{marginTop: '8px'}}>
														<Check color={"secondary"}/>
													</GridItem>

													<GridItem xs={10} sm={10} md={10} lg={10}
															  style={{marginTop: '8px'}}>
														<b
															style={{
																fontSize: '12pt',
																color: '#595959'
															}}>相关代码及内容的查看</b>
													</GridItem>
													<GridItem xs={1} sm={1} md={1} lg={1}
															  style={{marginTop: '8px'}}>
														<Check color={"secondary"}/>
													</GridItem>

													<GridItem xs={10} sm={10} md={10} lg={10}
															  style={{marginTop: '8px'}}>
														<b
															style={{
																fontSize: '12pt',
																color: '#595959'
															}}>黑板手绘展示题目讲解思路</b>
													</GridItem>
													<GridItem xs={1} sm={1} md={1} lg={1}
															  style={{marginTop: '8px'}}>
														<Check color={"secondary"}/>
													</GridItem>

													<GridItem xs={10} sm={10} md={10} lg={10}
															  style={{marginTop: '8px'}}>
														<b
															style={{
																fontSize: '12pt',
																color: '#595959'
															}}>每行代码详细注释解答</b>
													</GridItem>
													<GridItem xs={1} sm={1} md={1} lg={1}
															  style={{marginTop: '8px'}}>
														<Check color={"secondary"}/>
													</GridItem>
												</GridContainer>

											</CardBody>
										</Card>
									</GridItem>
								</GridContainer>

							</GridContainer>
							<GridContainer style={{paddingBottom: '32px'}}/>
						</div>
					</div>
					{/* PRICING CARDS END */}
				</div>
			</div>
		</div>
	);
}
